import type { FunctionComponent } from "react"

import { clsx } from "clsx"

import { Divider as UIKitDivider } from "@jobteaser/ui-kit/components/Divider/Divider"

import styles from "./Divider.module.css"

type DividerProps = {
  className?: string
}

export const Divider: FunctionComponent<DividerProps> = ({ className }) => (
  <UIKitDivider className={clsx(styles.main, className)} />
)
